<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md12
      >

      

        <material-card
          color="green"
          title="Send Message To All"
        >

         <v-form  ref="form">

            
                  <v-container py-0>
                  <v-layout wrap>
                 
                    <v-flex class="md12">
                     	  <v-text-field type="text"  v-model="messageData.title"  class="mt-4" placeholder="Message Title"></v-text-field>
                    </v-flex>
                    
                    <v-flex class="md12">
                     	  <v-text-field type="text" v-model="messageData.message"  class="mt-4" placeholder="Message Body"></v-text-field>
                    </v-flex>                   
                
                 <v-flex md6>
                        <v-text-field
                          v-model="thumbnailName"
                          label="Thumbnail"
                          @click="pickThumbnail"
                          prepend-icon="attach_file"
                          class="green-input"
                        ></v-text-field>
                        <input
                          type="file"
                          style="display: none"
                          ref="thumbnail"
                          accept="image/*"
                          @change="onThumbnailPicked"
                        />
                      </v-flex>
                 <v-flex md6>
                  <v-layout wrap style="padding-top: 25px;">
                 
                    <v-flex class="md4">
                     	  <label> Select App Location</label>
                    </v-flex>
                    
                    <v-flex class="md8">
                     	   <select style="width:100%" v-model="messageData.navigate_to_app_location"  class="form-control">
                              <option value="null" selected="selected" >None</option>
                              <option value="daily_quiz">Daily Quiz</option>
                              <option value="crash_course">Crash Course</option>
                              <option value="health_tips">Health Tips</option>
                              <option value="university_premium_course">Premium course</option>
                              <option value="selection_test">Selection Test</option>
                              <option value="smart_study_progress">Smart Study Progress</option>
                              <option value="learning_analytics">Learning Analytics</option>
                              <option value="admission_calculator">Admission Calculator</option>
                              <option value="admission_assistance">Admission Assistance</option>                            
                            </select>
                    </v-flex>
                     </v-layout>
                     
                      </v-flex>
           

                    <v-flex
                      xs12
                      text-xs-right>
                      <v-btn  :disabled="!messageData.title || !messageData.message "
                        class="mx-0 font-weight-light"
                        color="success" @click="sendMessage" >Send Message</v-btn>
                    </v-flex> 
                  </v-layout>
                </v-container>

                    
                          
                          <!-- <div class="modal-footer">
                            <button
                              :disabled="!messageData.title || !messageData.message || !selectedTutorsId.length"
                              type="submit"
                              class="btn btn-primary"
                            >Send</button>
                            <button
                             @click="closeMessageModal"
                              type="button"
                              ref="closeSendMessageModal"
                              class="btn btn-default"
                              data-dismiss="modal"
                            >Close</button>
                          </div> -->
                      </v-form>

        </material-card>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div> {{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
// import Form from '@/views/Form'
import xlsx from "xlsx";
export default {
  // components: {
  //   Form
  // },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('sendUserMessage', []),
  },
  mounted () {
   
  },
  data () {
    return {
    thumbnailName: "",
    messageData: {},
    color: null,
    colors: ['warning'],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
    noticeMessage: '',
     
    }
  },
  created () {
  },
  methods: {
      ...mapActions("sendUserMessage", [ "sendUserMessage"]),

    pickThumbnail() {
      this.$refs.thumbnail.click();
    },
    onThumbnailPicked(e) {
      this.thumbnailName = e.target.files[0].name;
    },
    async sendMessage() {
     let loader = this.$loading.show({
              color: "green",
              canCancel: false,
              onCancel: this.onCancel,
              loader: 'dots',
              isFullPage: true
            });
            
     let obj = {       
        title: this.messageData.title,
        message: this.messageData.message,
        navigate_to_app_location: this.messageData.navigate_to_app_location ? this.messageData.navigate_to_app_location : null
     }

      let thumbnail = this.$refs.thumbnail.files[0] 
   
      var formData = new FormData();
      formData.append('data', JSON.stringify(obj))
      formData.append('thumbnail', thumbnail);
     
      this.sendUserMessage(formData).then(response => {
        console.log(response)
         loader.hide()
        if (response.status == "OK") {       
         
          this.color = "success";        
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
          this.messageData = {};
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
        }
      
      }).catch(err => {
          console.log(err);
           loader.hide()
        });      
    },

    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }

      // this.color = this.colors[Math.floor(Math.random() * this.colors.length)]

      this.snackbar = true
    }
  }
}
</script>
